    import NavBar from "../navbar";
    import '../../themes/global.css'
    import './assets/static/notFound.css'

    export default function NotFound() {
        return (
            <>
                <main>
                    <span className="sidebar"></span>
                    <div className="content">
                        <span className="notFoundMessage">Uh oh! Something went wrong. We couldn't find this page.</span>
                    </div>
                    <span className="sidebar"></span>
                </main>
            </>
    )
}